
export class Profiles {
    public static PRODUCTION = 'prod';
    public static SWAGGER = 'swagger';
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/profiles.model.ts